import { create } from 'zustand'
import i18next from 'i18next'
import PatientService from '@/services/PatientService'
import notifyApiError from '@/utils/notifyApiError'
import { useMessageStore } from '@/stores/messageStore'
import type { EmployeeStore } from '@/types'

export const useEmployeeStore = create<EmployeeStore>((set, get) => ({
  employees: [],
  isLoading: false,
  hasFetched: false,

  fetchEmployees: async () => {
    if (get().hasFetched) return

    set({ isLoading: true })

    try {
      const res = await PatientService.getEmployees()
      const data = res?.data as { employees?: unknown[] }
      set({ employees: (data?.employees ?? []) as EmployeeStore['employees'], isLoading: false, hasFetched: true })
    } catch (err: unknown) {
      set({ isLoading: false })
      notifyApiError(err, { t: i18next.t.bind(i18next), showMessage: useMessageStore.getState().showMessage })
    }
  },

  reset: () => {
    set({ employees: [], isLoading: false, hasFetched: false })
  },
}))
